import { decodeHTML } from 'entities';

export const toPlainText = (value: string): string =>
  decodeHTML(value)
    .replace(/<\/?[a-zA-Z][^>]*>/g, ' ')
    .replace(/\s{2,}/g, ' ')
    .trim();
